import React from "react";
import content from "../content/footer.json"
import {useContent} from "../customHooks/useContent";

export const Footer = () => {
    const text = useContent(content);

    return (
        <footer className="container-fluid">
            <div className="container">
                <div>
                    <h2>{text.contact}</h2>
                    <p>
                        {text?.department}<br />
                        {text?.institute}, {text.university}<br />
                        {text?.address}<br />
                        {text?.city}<br />
                        {text?.phone}<br />
                        {text?.fax}<br />
                        e-mail: <a href="mailto:a.soltysiak@uw.edu.pl">a.soltysiak@uw.edu.pl</a>
                    </p>
                </div>
                <div className="copyright-note">
                    <div>Done by WPAS, 2018-2020</div>
                    <div>&copy; {text?.department}, {text?.university}</div>
                </div>
            </div>
        </footer>
    )
};

